import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { MdOutlineClose } from "react-icons/md";

export default function Modal({ show, setShow, item, product }) {
  function closeModal() {
    setShow((prev) => !prev);
  }

  return (
    <>
      <Transition appear show={show} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full w-full items-center justify-center p-4 ">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="lg:w-2/5 w-full transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex   items-center text-white bg-[#0065cc] p-2 ">
                    <Dialog.Title
                      as="div"
                      className="flex  w-full justify-center "
                    >
                      <h1 className="text-2xl font-semibold  text-white mb-4">
                        Ineligible Reason
                      </h1>
                    </Dialog.Title>
                    <div onClick={closeModal} className="cursor-pointer">
                      <MdOutlineClose />
                    </div>
                  </div>
                  <div className="flex flex-col justify-around space-y-4  w-full xl:h-[45vh] lg:h-[60vh] h-[75vh]">
                    <div
                      className="flex flex-col space-y-6"
                      style={{ overflowY: "auto", marginTop: "1rem" }}
                    >
                      <div className="flex mx-8  font-Poppins items-center ">
                        <h1 className="text-lg  font-semibold w-1/3 ">
                          Product Name:
                        </h1>
                        <p className="w-2/3">{product}</p>
                      </div>
                      <div className="flex mx-8 font-Poppins ite ">
                        <h1 className="text-lg  font-semibold w-1/3">
                          Reason:
                        </h1>
                        <ul className="w-2/3">
                          {item["Reason"] &&
                            Object.keys(item["Reason"]).map((key) => (
                              <li key={key}>{item["Reason"][key]}</li>
                            ))}
                        </ul>
                      </div>
                    </div>
                    <div className="flex mx-8 ">
                      <button className="p-3 mt-10 rounded-lg border-sky-400 border flex items-center text-blue-500 gap-2 hover:bg-[#0065cc] hover:text-white ">
                        <img
                          className="bg-white rounded-full"
                          src="/document-pdf.svg"
                          alt=""
                        />
                        Download PDF
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
